import { EChart } from '@kbox-labs/react-echarts';
import type { Dayjs } from 'dayjs';

import type { BarChartData, PeriodUnit } from '../type';
import { fillMissingDates, formatXAxisLabel } from './util';

type BarChartProps = {
  data: BarChartData[];
  periodUnit: PeriodUnit;
  between: [Dayjs, Dayjs];
};

const BarChart = ({ data, periodUnit, between }: BarChartProps) => {
  const filledData = fillMissingDates(data, periodUnit, between);

  const labelNameList = Object.keys(filledData.at(0)?.labelData ?? {});
  const seriesDataList = labelNameList.map(labelName => ({
    name: labelName,
    type: 'bar',
    data: filledData.map(
      item =>
        item.labelData[labelName].aiCount +
        item.labelData[labelName].humanCount,
    ),
    color: filledData.map(item => item.labelData[labelName].color),
    stack: 'label',
  }));

  return (
    <EChart
      style={{ width: '100%', height: '321px' }}
      tooltip={{
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
        },
      }}
      legend={{
        data: labelNameList,
        top: '0%',
        right: '0%',
        itemWidth: 12,
        itemHeight: 12,
        textStyle: {
          fontSize: 12,
        },
      }}
      grid={{
        left: '0%',
        right: '0%',
        bottom: '0%',
        top: '15%',
        containLabel: true,
      }}
      xAxis={{
        type: 'category',
        data: filledData.map(item => item.timeStamp),
        axisLabel: {
          rotate: 15,
          formatter: timestamp => formatXAxisLabel(timestamp, periodUnit),
          align: 'center',
          margin: 20,
          color: '#000',
        },
      }}
      yAxis={{
        type: 'value',
        axisLabel: {
          color: '#000',
        },
      }}
      series={seriesDataList as any}
    />
  );
};

export default BarChart;
